import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import Link from '../../Link/Link';
import messages from '../../../locale/messages';
import s from './ListingManagement.css';
import { getDocumentsByCategory } from '../../../helpers/listingDocumentStatusFilter';

const DOC_CATEGORIES = [
  { key: 'proof_of_insurance', labelMessage: messages.adminDocumentInsurance },
  { key: 'proof_of_maintenance_record', labelMessage: messages.adminDocumentMaintenance },
  { key: 'proof_of_ownership', labelMessage: messages.adminDocumentOwnership },
];

const statusMessage = (status) => {
  if (status === 'approved') return messages.carDocumentList_approved;
  if (status === 'rejected') return messages.carDocumentList_rejected;
  return messages.carDocumentList_pending;
};

const DocumentStatusCell = ({ documents, listId, userId }) => {
  const byCategory = getDocumentsByCategory(documents);

  return (
    <div className={s.documentCell}>
      {DOC_CATEGORIES.map(({ key, labelMessage }) => {
        const doc = byCategory[key];
        const status = doc ? doc.status : 'missing';
        return (
          <div key={key} className={s.documentRow}>
            <span className={s.documentLabel}>
              <FormattedMessage {...labelMessage} />:
            </span>
            <span className={cx(s.documentStatus, s[`status_${status}`])}>
              <FormattedMessage {...statusMessage(status)} />
            </span>
          </div>
        );
      })}
      <Link
        to={{
          pathname: `/siteadmin/carDocuments/${listId}`,
          state: { userId },
        }}
        className={s.documentReviewLink}
      >
        <FormattedMessage {...messages.adminDocumentReview} />
      </Link>
    </div>
  );
};

DocumentStatusCell.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string,
    status: PropTypes.string,
  })),
  listId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  userId: PropTypes.string,
};

export default withStyles(s)(DocumentStatusCell);
